// eslint-disable-next-line import/prefer-default-export
export const EMOJI_ANIMATION_TIME = 10000;
export const EMOJI_BUBBLE_ANIMATION_TIME = 4000;

export const MODE_CONTROL_CAMERA_CONTROL = 'MODE_CONTROL_CAMERA_CONTROL';
export const MODE_EMOJI_STICKER = 'MODE_EMOJI_STICKER';
